module.exports = __webpack_public_path__ + "public/img/icon_yinliuhuoke.e6a38857.png";